import { render, staticRenderFns } from "./BackofficeTopNavBar.vue?vue&type=template&id=23447bf0"
import script from "./BackofficeTopNavBar.vue?vue&type=script&lang=ts"
export * from "./BackofficeTopNavBar.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeTopNavBar.vue?vue&type=style&index=0&id=23447bf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports